import React, { useState, useEffect } from 'react';
import { Tabs, Space, Table, Modal } from 'antd';
import type { TabsProps } from 'antd';
import { Button, Form, Spin } from 'antd';
import { UserOutlined, ContactsOutlined, UsergroupAddOutlined } from '@ant-design/icons';
import axios from 'axios';
import { color } from '@mui/system';
import Tab1 from './Tab1';
import { Money, Print, Save, ViewAgenda, ViewColumn } from '@mui/icons-material';
import Utilisateur from '../../../../Models/Utilisateur';
import { useAuthHeader, useAuthUser } from '../../../../Services/Auth/sessionAuth';
import Data from '../../../../Data/Data.json'
import Utilis from '../../../../Models/Utilis';
import DistantProfils from '../../../../Models/DistantProfils';
import SweetAlert from "sweetalert2"
import { Crypter } from '../../../../Functions/Security/Crypter';
import Hash from '../../../../Functions/Security/Hash';
import { Box, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Slide, Typography, styled } from '@mui/material';
//import "../../Assets/Styles/StyleForm.css";
import Params from '../../../../Types/ParamsPicklist';
import DataTypeTable from '../../../../Types/DataTypeTable';
import Datas from "../../../../Data/Data.json";
import { ColumnsType } from 'antd/es/table';
import { useNavigate } from 'react-router-dom';
import formatDate from '../../../../Functions/Traitement/fomatDate';
import ReformatDate from '../../../../Functions/Traitement/ReformatDate';
import Garantie from '../../../../Models/Garantie';
import Caisse from '../../../../Models/Caisse';
import Tab2 from './Tab2';
import formatNumber from '../../../../Functions/Traitement/FormatNumber';
import { TransitionProps } from '@mui/material/transitions';
import ParamsPicklist from '../../../../Types/ParamsPicklist';
import ReformatNumber from '../../../../Functions/Traitement/ReformatNumber';
import OperationCaisse from '../../../../Models/OperationCaisse';
import { PrintRecuCaisseDirect } from '../../../../utilitaires/globalFunction';
import { number } from 'yup';
import { InitBilletage } from '../../../../Functions/Traitement/ClearBilletage';
import { LoadBilletage } from '../../../../Functions/Traitement/LoadBilletage';

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});



//CreateNewCLIENT
//const Swal = require('sweetalert2');
//let LinkSourceApi= require('../../Data/Data.json');

const EmissionReceptionFond = () => {
  // USER SESSION
  const auth = useAuthUser()
  const user: Utilisateur = JSON.parse(JSON.stringify(auth()))
  const navigate = useNavigate()

  // USER TOKEN
  const authHeader = useAuthHeader()

  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [StartSearchG, SeStartSearchG] = useState(false);
  const [StartForm, SetStartForm] = useState(true);
  const [, forceUpdate] = useState({});
  const [isSubmit, setIsSubmit] = useState(false)
  const [ajoutActve, setAjoutActif] = useState(false)
  const [modifActve, setModifActve] = useState(true)
  const [enregActve, setEnregActve] = useState(true)
  const [supActive, setSupActive] = useState(true)
  const [impActive, setImpActive] = useState(true)
  const [actuActive, setActActive] = useState(true)
  const [annulActive, setAnnulActive] = useState(true)
  const [consulActive, setConsulActive] = useState(false)
  const [sbmit, setSbmit] = useState("")
  const [action, setAction] = useState("")

  const [Data, SetData] = useState<any[]>([]);
  const [scroll, setScrool] = useState<any>({ y: 250, x: 10 })
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [pageLoad, setPageLoad] = useState(true)
  const [radioaCheck, setRadioaCheck] = useState(false)
  const [data, setData] = useState<any[]>([])

  const [txtEntete, setTxtEntete] = useState("")

  const [caisse, setCaisse] = useState<any>()

  const ThemeTable = styled(Table)(({ theme }) => ({

    ".ant-table-body ": {
      height: '185px',
      borderBottom: '1px var(--colorOpaque020) solid',
    }

  }
  ));

  const columns: ColumnsType<any> = [
    {
      title: 'Order',
      dataIndex: 'ORDRE',
      width: "150px"
    },
    {
      title: 'Agence',
      dataIndex: 'AEGECE',
      width: "150px"
    },
    {
      title: "Caisse emis",
      dataIndex: 'NOCAEM',
      width: "150px"
    },
    {
      title: "Date emis",
      dataIndex: 'DATEMIS',
      width: "150px"
    },
    {
      title: 'Emetteur',
      dataIndex: 'CAIUTIEMI',
      width: "200px"
    },
    {
      title: 'Montant',
      dataIndex: 'MONTAN',
      width: "150px"
    }
  ];

  // useEffect(() => {
  //   form.setFieldValue("DateOpe", user.datjour)
  // })

  setTimeout(() => {
    if (selectedRowKeys.length == 0) {
    }
    try {
      let reset = localStorage.getItem(Datas.LocalVariable.reset)
      if (reset == "1") {
        setSelectedRowKeys([])
        //localStorage.clear()
      }
    }
    catch (error) {
      console.log(error)
    }
  }, 1);


  const onSelectChange = (newSelectedRowKeys: any) => {

    // form.setFieldsValue(data[newSelectedRowKeys])

    setSelectedRowKeys(newSelectedRowKeys);

    form.setFieldValue("NODECE_RECEP", caisse.NODECE)
    form.setFieldValue("lib_NODECE_RECEP", caisse.LECEON)
    form.setFieldValue("CAIUTI_RECP", caisse.CAIUTI)
    form.setFieldValue("NUMCPT_RECP", caisse.NUMCPT)


    form.setFieldValue("CODOPE", "908")
    form.setFieldValue("lib_CODOPE", "")

    form.setFieldValue("ORDRE", data[newSelectedRowKeys].ORDRE)
    form.setFieldValue("AEGECE", data[newSelectedRowKeys].AEGECE)

    form.setFieldValue("NODECE", data[newSelectedRowKeys].NOCAEM)
    form.setFieldValue("NOCARE", data[newSelectedRowKeys].NOCARE)
    form.setFieldValue("montantOpe", data[newSelectedRowKeys].MONTAN)
    form.setFieldValue("LECEON", data[newSelectedRowKeys].CAIUTIEMI)
    form.setFieldValue("CAIUTIREC", data[newSelectedRowKeys].CAIUTIREC)
    form.setFieldValue("DateOpe", ReformatDate(data[newSelectedRowKeys].DATEMIS))
    form.setFieldValue("TIMEMI", data[newSelectedRowKeys].TIMEMI)
    form.setFieldValue("DATREC", data[newSelectedRowKeys].DATREC)
    form.setFieldValue("TIMRE", data[newSelectedRowKeys].TIMRE)
    form.setFieldValue("CDETAT", data[newSelectedRowKeys].CDETAT)
    form.setFieldValue("NUMCPT", data[newSelectedRowKeys].CPTEMIRECFONDS)
    form.setFieldValue("ORDRE", data[newSelectedRowKeys].ORDRE)

    //alert(JSON.stringify(data[newSelectedRowKeys]))
    setEnregActve(false)
    setAnnulActive(false)

    setOpen(false)

    LoadBilletage({
      form: form,
      authHeader: authHeader(),
      user: user,
      Ref: data[newSelectedRowKeys].ORDRE,
      ColRef: "orderRef",
      Table: 'BilletageOperation',
      // onDouble: true
    })
  }; const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  useEffect(() => {
    forceUpdate({});
  }, []);

  function initialiazeButton() {
    setAjoutActif(false)
    setModifActve(true)
    setEnregActve(true)
    setSupActive(true)
    setImpActive(true)
    setActActive(true)
    setAnnulActive(true)
    setConsulActive(false)
  }

  const SetStart = () => {
    //alert(form.getFieldValue("CDETAT"))
    if (form.getFieldValue("CDETAT") == "50") {
      setSbmit("add")
      setAjoutActif(true)
      setEnregActve(false)
      setAnnulActive(false)
      setConsulActive(true)
      setModifActve(true)
      form.resetFields()

      localStorage.setItem(Datas.LocalVariable.reset, "0")

      form.setFieldValue("niveau", 900)
      form.setFieldValue("DateOpe", user.datjour)

      // -------------------- //

      LoadTillInformation()
      form.setFieldValue("CODOPE", 907)

      // -------------------- //
    } else {
      navigate("/")
      SweetAlert.fire({ title: "Votre caisse n'est pas ouverte", icon: "warning" })
    }

  }

  const SetEndStart = () => {
    SetStartForm(true);
    SeStartSearchG(false)
    setModifActve(false)
  }
  function handleAnulle() {
    let NODECE = form.getFieldValue("NODECE")
    let LECEON = form.getFieldValue("LECEON")
    let CDETAT = form.getFieldValue("CDETAT")
    let NUMCPT = form.getFieldValue("NUMCPT")
    form.resetFields()
    localStorage.clear()

    form.setFieldValue("NODECE", NODECE)
    form.setFieldValue("LECEON", caisse.LECEON)
    form.setFieldValue("CDETAT", CDETAT)
    form.setFieldValue("NUMCPT", NUMCPT)

    form.setFieldValue("CAIUTI", user.nomuti)

    initialiazeButton()
    localStorage.setItem(Datas.LocalVariable.reset, "1")
    SetData([])
    //localStorage.setItem(Datas.LocalVariable.resetTable, "1")

    InitBilletage({
      form: form,
      authHeader: authHeader(),
      value: '0',
    })
  }
  function cunsultButton() {
    setAnnulActive(false)
    setModifActve(false)

  }

  function modifButton() {
    setSbmit("update")
    setModifActve(true)
    setAjoutActif(true)
    setEnregActve(false)
    setConsulActive(true)
    setAnnulActive(false)
  }

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    loadReceptionFonds(caisse.NODECE)
    setSelectedRowKeys([])
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };


  const items: TabsProps['items'] = [
    {
      key: '1',
      label: (
        <span id='Tab'>
          <UserOutlined />
          Emission fonds
        </span>
      ),
      children: <Tab1 form={form} />,
    },
    {
      key: '1',
      disabled: ajoutActve,
      label: (
        <Button style={{ background: "none", color: "white", border: "none" }} disabled={ajoutActve} size='small' onClick={handleClickOpen}>
          <span id='Tab'>
            <UserOutlined />
            Reception fonds
          </span>
        </Button>
      ),
      children: <div>
        <Dialog
          open={open}
          TransitionComponent={Transition}
          keepMounted
          onClose={handleClose}
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle>{txtEntete}</DialogTitle>
          <DialogContent>
            <Spin spinning={loading}>
              <Form disabled={radioaCheck}><br />
                <Table size='small' style={{ width: 'auto' }} rowSelection={{ ...rowSelection, type: "radio", }} columns={columns} dataSource={data} scroll={{ y: 350, x: "auto" }} pagination={false} />
              </Form>
            </Spin>
          </DialogContent>
          <DialogActions>
            <Button disabled={false} onClick={handleClose}>Fermer</Button>
          </DialogActions>
        </Dialog>
      </div>,
    }
  ];

  function LoadTillInformation(first?: true) {
    setLoading(true)
    let utilis: Utilisateur = user
    //alert(JSON.stringify(utilis))
    let config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: Datas.ApiUrl.GetTillStatut,
      headers: {
        'CipherUser': Crypter.encrypt(JSON.stringify(utilis)),
        'Authorization': authHeader(),
        'Content-Type': 'application/json'
      },
    };
    axios.request(config)
      .then((response) => {
        if (response.data) {
          const res = JSON.parse(Crypter.decrypt(response.data)).Value;

          //form.setFieldsValue(res.Result[0])

          if (res.StatutCode == 200) {
            localStorage.clear()
            // if (!first) {
            form.setFieldsValue(res.Result[0])
            // }

            if (res.Message == 'Votre caisse est cloturé' || res.Message == 'Votre caisse est fermé') { // Lorsque la caisse est déjà ouverte

              navigate("/")

            } else {

              setCaisse(res.Result[0])


              // Initialiser le billetge à 0
              InitBilletage({
                authHeader: authHeader(),
                form: form,
                value: "0"
              })

              loadReceptionFonds(first, res.Result[0].NODECE)
              if (!first) {

                // for (var i = 1; i <= 13; i++) {
                //   form.setFieldValue((i <= 9 ? "NOMB0" : "NOMB") + i, "0")
                //   form.setFieldValue((i <= 9 ? "D_NOMB0" : "D_NOMB") + i, formatNumber(res.Result[0][(i <= 9 ? "NOMB0" : "NOMB") + i]))
                // }

                // chargement du billetage
                // LoadBilletage({
                //   form: form,
                //   authHeader: authHeader(),
                //   user: user,
                //   Ref: res.Result[0].NODECE,
                //   ColRef: "CodeCaisse",
                //   Table: 'BilletageCaisse',
                //   // onDouble: true
                // })
              }
            }

          }
          else {
            navigate("/")
            SweetAlert.fire({ title: res.Message, icon: "warning" })
          }
        }
        setLoading(false)
      })
      .catch((error) => {
        navigate("/")
        setLoading(false);
        console.log(error)
        SweetAlert.fire({ title: error, icon: "error" })
      });
  }
  if (pageLoad) {
    setPageLoad(false)
    LoadTillInformation(true)

    form.setFieldValue("DateOpe", user.datjour)
    //alert(user.datjour)
  }

  function loadReceptionFonds(first?: true, caiss?: string) {
    //let caiss= caisse.NODECE

    // let search: ParamsPicklist = { CodeAgence: user.codage, Table: "EMIRECFONDS", Colonne1: "NOCARE", Colonne2: "", Colagence: '101', Init: caiss, Choix: 31 }

    let search: Params = { CodeAgence: user.codage, Table: "EMIRECFONDS", Colonne1: "NOCARE", Colonne2: "", Colagence: '101', Init: caiss, Choix: 35 }
    setLoading(true)
    //form.resetFields()
    let config: any = {
      method: 'get',
      maxBodyLength: Infinity,
      url: Datas.ApiUrl.AnySearch,
      headers: {
        'CypherSearch': Crypter.encrypt(JSON.stringify(search)),
        'Authorization': authHeader(),
        'Content-Type': 'application/json'
      },
    };
    axios.request(config)
      .then((response) => {
        setLoading(false);
        if (response.data) {
          const res = JSON.parse(Crypter.decrypt(response.data)).Value;

          if (res.StatutCode == 200) {
            //alert(JSON.stringify(res.Result.Table))

            let dta: any = []

            res.Result.Table.map((e: any, indexe: number) => {
              if (e.CDETAT == "") {
                dta.push(
                  {
                    ...e
                  }
                )
              }
            })

            let dta1: any = []

            dta.map((e: any, indexe: number) => {
              dta1.push(
                {
                  "key": indexe,
                  ...e
                }
              )
            })

            setData(dta1)
            setTxtEntete((dta1.length == 0) ? "Aucun fond entrant" : dta1.length + " fond(s) entrant(s)")

            if (first) {
              if ((dta1 as []).length != 0) {
                setOpen(true)
              }
            }
          }
        }
        setLoading(false)
      })
      .catch((error) => {
        setLoading(false);
        console.log(error)
        SweetAlert.fire({ title: error, icon: "error" })
      });


  }

  function loadAccountInformations(numcpt: string, dataOpeParam?: any) {
    setLoading(true)
    //var data = { CodeAgence: form.getFieldValue("CODAGE"), Table: "COMPTES", Colonne1: "NUMCPT", Colonne2: "NOMCPT", Colagence: form.getFieldValue("CODAGE"), Init: numcpt, choix: 33 }
    //alert(JSON.stringify(data))
    var config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: Datas.ApiUrl.GetCompte,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': authHeader(),
        'CypherNumCpte': Crypter.encrypt(numcpt)
      }
    };

    axios(config)
      .then((response) => {
        //alert('ok')
        if (response.data) {
          const res = JSON.parse(Crypter.decrypt(response.data));

          if (res.StatutCode == 200) {
            let datas = res.Result.Table;
            //form.setFieldsValue(datas[0])
            //console.log(datas[0])

            form.setFieldValue("AUTORI", formatNumber(datas[0].AUTORI))
            form.setFieldValue("BLOQUE", formatNumber(datas[0].BLOQUE))
            form.setFieldValue("DISPON", formatNumber(datas[0].DISPON))
            form.setFieldValue("CDDEVS", datas[0].CDDEVS)
            form.setFieldValue("CODAGE", datas[0].AGCCPT)
            form.setFieldValue("CDGESTCLI", datas[0].CDGESTCLI)

            form.setFieldValue("lib_CDDEVS", datas[0].lib_CDDEVS)
            form.setFieldValue("lib_CODAGE", datas[0].lib_AGCCPT)
            form.setFieldValue("lib_CDGESTCLI", datas[0].lib_CDGESTCLI)
            form.setFieldValue("lib_NUMCPT", datas[0].NOMCPT)
            form.setFieldValue("NUMCPT", datas[0].NUMCPT)

            // setDataOpe({
            //   ...dataOpeParam,
            //   "CODAGE": datas[0].AGCCPT,
            //   "lib_CODAGE" : datas[0].lib_AGCCPT,
            //   "lib_NUMCPT" : datas[0].NOMCPT

            // })

            //-----

          }
          else {
            SweetAlert.fire({ title: res.Message, icon: 'error' })
          }
        }
        setLoading(false);

      }).catch((error) => {
        //console.log(error)
        setLoading(false);
        // SweetAlert.fire({title: "Error", text : error})
      })
  }

  const onFinish = (values: any) => {
    //alert(JSON.stringify(values))
    if (values.montantOpe == ReformatNumber(form.getFieldValue("TotalBilletage"))) {
      var op: OperationCaisse = values
      op.TypeOpe = form.getFieldValue("TypeOpe")
      op.NODECE = op.CODOPE == '908'? form.getFieldValue("NODECE_RECEP") : form.getFieldValue("NODECE")
      op.CAIUTI = form.getFieldValue("CAIUTI")
      op.UTISAI = user.coduti
      op.DateDeliv = formatDate(op.DateDeliv)
      op.DateOpe = formatDate(op.DateOpe)
      op.DateVal = formatDate(op.DateVal)
      op.DISPON = ReformatNumber(form.getFieldValue("DISPON") ? form.getFieldValue("DISPON") : "0")
      let value = op.CODOPE
      op.ORDREMAD = form.getFieldValue("ORDRE")
      //alert(JSON.stringify(op))
      op.TypeOpe = op.CODOPE == '907' ? "RET" : "VER"
      op.NUMCPT = values.NUMCPT_RECP
      op.CODAGE = user.codage
      op.AGCEDEPART = user.codage

      op.lib_NUMCPT = values.lib_NUMCPT_RECP

      op.DateDeliv = '2016-10-06 00:00:00.000'
      op.DateVal = '2016-10-06 00:00:00.000'
      op.Billetages = form.getFieldValue("Billetages")


      //alert(op.CODOPE)

      SweetAlert.fire({
        title: ((value == '907') ? "EMISSION DE FONDS" : "RECEPTION DE FONDS") + " de " + formatNumber(parseInt(op.montantOpe)) + " XAF\nEmetteur :  " + (op.CAIUTI ? op.CAIUTI : "") + '(' + op.NODECE + ')' + "\nRecepteur : " + values.CAIUTI_RECP + '(' + values.NODECE_RECEP + ')',
        showCancelButton: true,
        color: "green",
        confirmButtonText: "Yes",
        confirmButtonColor: "green",
        cancelButtonColor: "darkred",
        cancelButtonText: "No",
        showLoaderOnConfirm: true,
        icon: 'question'
      }).then((res) => {
        if (res.isConfirmed) {
          try {

            setLoading(true);
            setIsSubmit(true)

            let config = {
              method: 'post',
              maxBodyLength: Infinity,
              url: Datas.ApiUrl.OperationsCaisse,
              headers: {
                'Authorization': authHeader(),
                'Content-Type': 'application/json'
              },
              data: Crypter.encrypt(JSON.stringify(op)),
            };

            axios.request(config)
              .then((response) => {
                setLoading(false);
                if (response.data) {
                  const res = JSON.parse(Crypter.decrypt(response.data)).Value;
                  //alert(res.StatutCode)
                  if (res.StatutCode == 200) {

                    handleAnulle()
                    setIsSubmit(false)
                    SweetAlert.fire({ title: res.Message, icon: "success" })
                    initialiazeButton()
                    localStorage.setItem(Datas.LocalVariable.reset, "1")
                    initialiazeButton()
                    setSbmit("")

                    //Impression Recu
                    op.NUMSEQ = res.Message.split(" : ")[1]
                    op.CAIUTI = user.nomuti
                    op.lib_CODAGE = user.agence


                    op.CODOPE1 = op.CODOPE

                    let data = { "form": op }
                    localStorage.setItem(Datas.LocalVariable.Recu, JSON.stringify(data))
                    //navigate("/operation/Deposit&withdrawal/print")
                    //navigate("/caisse/veresmentretrait/print")
                    PrintRecuCaisseDirect(user.codage, user.agence, user.nomuti, op.NODECE, op.NUMSEQ, op.UTISAI, op.lib_CODOPE, "XAF", "FRANC CFA BEAC", op.CODOPE1, op.NUMCPT, Number(op.montantOpe), "pdf")
                    //  handleDownloadRecuDirect(op.NODECE,op.NUMSEQ,op.UTISAI,op.lib_CODOPE,op.CDDEVS,op.lib_CDDEVS,op.CODOPE1,op.NUMCPT,Number(op.montantOpe),op.CDDEVS,"pdf")

                  }
                  else {
                    SweetAlert.fire({ title: res.Message, icon: "warning" })
                  }
                }
              })
              .catch((error) => {
                setLoading(false);
                console.log(error)
                SweetAlert.fire({ title: error, icon: "error" })
              })

          } catch (error) {
            SweetAlert.fire({ title: 'Error ocured while getting warranties or avalistes', icon: "error" })
          }
        }
      })
    } else {
      SweetAlert.fire({ title: 'Votre Bielletage est incorrect', icon: "warning" })
    }
  };

  const onFinishFailed = async (errorInfo: any) => {
    var errors: any = [];

    errorInfo.errorFields.map((error: any) => {

      errors.push(error.name + "");
    })

    SweetAlert.fire({ title: "Veuillez remplir tous les champs obligatoires", text: errors.toString().replaceAll(',', " - "), icon: 'warning', confirmButtonText: 'OK' })

  };

  function Print() {
    try {
      localStorage.setItem(Datas.LocalVariable.tabGarantie, JSON.stringify({ "columns": Data, "data": Data, "form": undefined }))
      navigate("/garranty/print")
    } catch (error) {
      SweetAlert.fire({
        title: "Warning",
        text: JSON.stringify(error),
        icon: "warning"
      })
    }
  }

  function OuvertureCaisse() {
    setAction("O")
  }
  function FermetureCaisse() {
    setAction("F")
  }

  function consult() {

  }




  return (
    <div className='tab'>
      <Typography align='center' className='formTitle'><b>{window.location.pathname}</b></Typography>
      <Spin spinning={loading} size='large' style={{ color: 'green' }} >
        <Form disabled={!ajoutActve} autoComplete="off" labelAlign='left' form={form} name="dynamic_form_complex" onFinish={onFinish} onFinishFailed={onFinishFailed} style={{ minWidth: 'auto', maxWidth: 'auto' }}>
          <div className='bG'>
            <legend><Typography color={"darkgreen"}>Actions</Typography></legend>
            <Form.Item shouldUpdate className='bouttong'>
              <Space direction="vertical" style={{ width: '100%' }}>
                <Button size='large' className='bt_add' disabled={ajoutActve} onClick={SetStart} type="ghost" htmlType="button" block  >
                  Emettre
                </Button>
                <Button size='large' className='bt_add' disabled={enregActve} type="ghost" htmlType="submit" block>
                  Enregistrer
                </Button>

                <Button size='large' className='bt_add' disabled={impActive} type="ghost" htmlType="button" block  >
                  Aperçu
                </Button>
                <Button size='large' className='bt_add' disabled={actuActive} type="ghost" htmlType="button" block  >
                  Actualiser
                </Button>
                <Button size='large' disabled={annulActive} onClick={handleAnulle} className='bt_add' type="ghost" htmlType="reset" block>
                  Annuler
                </Button>
              </Space>
            </Form.Item>
          </div>
          <div className='clientP'>
            <div >
              <Tabs size='small' type="card" defaultActiveKey="1" items={items} />
            </div>
            <div>
            </div>
          </div>
        </Form>
      </Spin>
    </div>
  );
}
export default EmissionReceptionFond;